import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const PlayTriangle = (props) => (
  <Icon viewBox="0 0 14 19" {...props}>
    <g>
      <path d="M.493 17.246V1.451a1.112 1.112 0 0 1 .572-.989A1.05 1.05 0 0 1 2.181.53l11.022 7.905c.29.209.464.55.464.916 0 .364-.173.706-.464.915L2.181 18.163a1.05 1.05 0 0 1-1.114.069 1.112 1.112 0 0 1-.574-.986z"
        fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default PlayTriangle;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/PlayTriangle.js